import type { SvgIconComponent } from '@mui/icons-material';
import AddBoxOutlinedIcon from '@mui/icons-material/AddBoxOutlined';
import AddLocationOutlinedIcon from '@mui/icons-material/AddLocationOutlined';
import AssignmentOutlinedIcon from '@mui/icons-material/AssignmentOutlined';
import DateRangeOutlinedIcon from '@mui/icons-material/DateRangeOutlined';
import DirectionsCarOutlinedIcon from '@mui/icons-material/DirectionsCarOutlined';
import EditLocationOutlinedIcon from '@mui/icons-material/EditLocationOutlined';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import LocationOnOutlinedIcon from '@mui/icons-material/LocationOnOutlined';
import MenuBookOutlinedIcon from '@mui/icons-material/MenuBookOutlined';
import NotificationsOutlinedIcon from '@mui/icons-material/NotificationsOutlined';
import PersonAddOutlinedIcon from '@mui/icons-material/PersonAddOutlined';
import PersonOutlinedIcon from '@mui/icons-material/PersonOutlined';
import PostAddOutlinedIcon from '@mui/icons-material/PostAddOutlined';
import QrCode2OutlinedIcon from '@mui/icons-material/QrCode2Outlined';
import RecyclingOutlinedIcon from '@mui/icons-material/RecyclingOutlined';
import SignalCellularAltOutlinedIcon from '@mui/icons-material/SignalCellularAltOutlined';
import StorageOutlinedIcon from '@mui/icons-material/StorageOutlined';
import TableRowsOutlinedIcon from '@mui/icons-material/TableRowsOutlined';
import TimelineOutlinedIcon from '@mui/icons-material/TimelineOutlined';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';

const KNOWLEDGE_ARTICLE_ICONS: Record<string, SvgIconComponent> = {
  pickup: AssignmentOutlinedIcon,
  'view-pickup-orders-list': TableRowsOutlinedIcon,
  'create-pickup-order-outlet': PostAddOutlinedIcon,
  'pickup-order-statuses': TimelineOutlinedIcon,
  'filter-pickup-orders-by-date': DateRangeOutlinedIcon,
  material: RecyclingOutlinedIcon,
  'add-material-type': RecyclingOutlinedIcon,
  'edit-material-type': EditOutlinedIcon,
  container: StorageOutlinedIcon,
  'add-container': AddBoxOutlinedIcon,
  'container-fill-level': SignalCellularAltOutlinedIcon,
  'container-statuses': InfoOutlinedIcon,
  'print-container-qr': QrCode2OutlinedIcon,
  'edit-or-delete-container': EditOutlinedIcon,
  'collection-site': LocationOnOutlinedIcon,
  'add-collection-site': AddLocationOutlinedIcon,
  'edit-or-delete-collection-site': EditLocationOutlinedIcon,
  truck: DirectionsCarOutlinedIcon,
  'add-vehicle': DirectionsCarOutlinedIcon,
  'truck-statuses': InfoOutlinedIcon,
  'edit-or-delete-vehicle': EditOutlinedIcon,
  driver: PersonOutlinedIcon,
  'add-driver': PersonAddOutlinedIcon,
  'view-driver-details': VisibilityOutlinedIcon,
  'edit-or-delete-driver': EditOutlinedIcon,
  'understanding-notifications': NotificationsOutlinedIcon,
};

export const getKnowledgeArticleIcon = (articleId: string): SvgIconComponent =>
  KNOWLEDGE_ARTICLE_ICONS[articleId] ?? MenuBookOutlinedIcon;
